import {
	ROUTE_TYPES_FETCH_REQUEST,
	ROUTE_TYPES_FETCH_RESPONSE,
	ROUTE_TYPES_FETCH_ERROR,
	ROUTE_TYPE_SELECT,
} from 'constants/ActionTypes';

const initialState = {
	available: [],
	loading: false,
	error: null,
	selected: localStorage.getItem('routeType') || '',
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ROUTE_TYPES_FETCH_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case ROUTE_TYPES_FETCH_RESPONSE:
			return {
				...state,
				loading: false,
				available: action.payload.data,
			};
		case ROUTE_TYPES_FETCH_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case ROUTE_TYPE_SELECT:
			return {
				...state,
				selected: action.payload.data,
			};
		default:
			return state;
	}
};

export default reducer;
